module.exports = __webpack_public_path__ + "img/stars-02.ba23d7e1.svg";